export var skeletonInputStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      flexDirection: 'column',
      justifyContent: 'center',
      display: 'inline-flex',
      position: 'relative',
      height: v.inputHeight,
      width: v.inputWidth,
      background: v.inputBackground
    }, p.fluid && {
      width: '100%'
    });
  }
};
//# sourceMappingURL=skeletonInputStyles.js.map
